//import isEmail from 'validator/lib/isEmail';

export function email(value) {
 // return value && !isEmail(value.trim()) ? 'Invalid email' : null;
 return true;
}





